export default {
  SET_PRICE: 'core/setPrice',
  SET_HISTORY: 'core/setHistory',
};
